<template>
    <div class="wrap-content data-segment-page">
        <div class="filter-section row-min-space">
            <div class="row">
                <div class="col-md-5 filter-title-section">
                    <h2>Data Segments</h2>
                </div>
                <div class="col-md-7 text-right">
                    <div class="row">
                        <div class="col-md-6 col-xs-12">
                            <div class="form-group search-input">
                                <i class="icon-search"></i>
                                <b-form-input
                                    v-model="query.keyword"
                                    :placeholder="'Search data segment'"
                                    autocomplete="no"
                                    @keyup.enter="applySearch('search')"
                                ></b-form-input>
                            </div>
                        </div>
                        <div class="col-md-6 col-xs-12 filter-btn-section">
                            <div class="row">
                                <div class="col-md-4 col-xs-12">
                                    <button
                                        class="btn btn-primary"
                                        type="submit"
                                        :class="
                                            loading && showPageLoader
                                                ? 'disabled'
                                                : ''
                                        "
                                        @click="applySearch('search')"
                                    >
                                        <span class="btn-text">Apply</span>
                                        <span class="loader"></span>
                                    </button>
                                </div>
                                <div class="col-md-8 col-xs-12">
                                    <b-button
                                        v-b-modal.add-data-segment-popup
                                        class="btn secondary-add-btn"
                                        variant="secondary"
                                        type="submit"
                                        :class="{
                                            'button-disabled': !hasScopes(
                                                'manage-data-segments'
                                            ),
                                        }"
                                    >
                                        <span class="btn-text"
                                            >+ Add Data Segment</span
                                        >
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- user management table -->
        <div
            :class="[
                'table-section',
                'tablet-table-xs-min-width',
                'mobile-table-responsive-lg',
                {
                    'overflow-hidden': !items.length && !showPageLoader,
                },
            ]"
        >
            <b-table
                :items="items"
                :fields="dataSegmentRecords"
                class="user-roles-table"
                no-local-sorting
                @sort-changed="sortingChanged"
            >
                <!-- status slot -->
                <template slot="status" slot-scope="data">
                    <base-status :status-type="data.item.status"></base-status>
                </template>

                <!-- action slot -->
                <template slot="action" slot-scope="data">
                    <div
                        :class="[
                            'action-review',
                            { disabled: !hasScopes('manage-data-segments') },
                        ]"
                    >
                        <!-- if action modify -->
                        <base-action
                            icon="icon-edit"
                            label="Modify"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('add-data-segment-popup')
                            "
                        ></base-action>
                        <!-- if action archive -->
                        <base-action
                            v-if="data.item.status == 'active'"
                            icon="icon-trash"
                            label="Archive"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('archive-popup')
                            "
                        ></base-action>
                        <!-- if action activate -->
                        <base-action
                            v-if="data.item.status == 'archived'"
                            icon="icon-done"
                            label="Activate"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('activate-popup')
                            "
                        ></base-action>
                    </div>
                </template>
            </b-table>
            <!-- When data is loading -->
            <base-table-spinner
                v-if="items.length == 0 && showPageLoader"
            ></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found
                v-if="items.length == 0 && !showPageLoader"
            ></base-no-record-found>
        </div>
        <pagination
            v-if="!showPageLoader"
            ref="pagination"
            :pagination="pagination"
            @pagination-changed="paginationChanged"
            @button-clicked-previous="applySearch('previous')"
            @button-clicked-next="applySearch('next')"
        ></pagination>
        <add-data-segment-popup></add-data-segment-popup>
        <archive-popup
            ref="archive-popup"
            record-type="data_segment"
            @update-status="updateStatus"
        ></archive-popup>
        <activate-popup
            ref="activate-popup"
            record-type="data_segment"
            @update-status="updateStatus"
        ></activate-popup>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import pagination from '@/components/Pagination.vue'
import addDataSegmentPopup from '@/components/popups/AddDataSegmentPopup.vue'
import archivePopup from '@/components/popups/ArchivePopup.vue'
import activatePopup from '@/components/popups/ActivatePopup.vue'
import Resource from '@/api/resource'
const apiResource = new Resource('access-control/data-segments/')

export default {
    components: {
        addDataSegmentPopup,
        archivePopup,
        pagination,
        activatePopup,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            query: {
                keyword: '',
                sortOrder: '',
                sortBy: '',
                startAt: 1,
                perPage: 10,
            },
            dataSegmentRecords: [],
            items: [],
            showPageLoader: true,
            pagination: {},
        }
    }, // End of Component > data
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'dataSegmentList',
            'dataSegmentFields',
            'selectedItem',
            'reload',
            'loading',
            'hasScopes',
        ]),
    }, // End of Component > computed
    watch: {
        reload(value) {
            if (value) {
                this.items = []
                this.query.startAt = 1
                this.getRecords()
            }
        },
    }, // End of Component > watch
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getRecords()
    }, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        //get records according to the applied filters
        async getRecords() {
            this.dataSegmentRecords = this.dataSegmentFields //push data into array
            this.showPageLoader = true
            let { data } = await apiResource.list(this.query)
            this.pagination = data.pagination
            this.pagination.totalRecords = data.data.length
            this.pagination.perPage = this.query.perPage
            this.items = data.data
            localStorage.setItem('dataSegmentList', JSON.stringify(this.items))

            this.showPageLoader = false
            this.$store.commit('setLoading', false)
        }, // End of getRecords() method

        //change the value of sorting order and sorted field
        sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy
            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'

            // this.getRecords()
            this.applySearch()
        }, // End of sortingChanged() method

        //set the value for selected record
        selectedRecord(record) {
            this.$store.commit('setItem', record)
        }, // End of selectedRecord() method

        //update the status of the record
        async updateStatus(status) {
            let params = {
                id: this.selectedItem._id,
                status: status,
                title: this.selectedItem.title,
                code: this.selectedItem.code,
            }
            await this.$store.dispatch('updateDataSegment', params)
            this.$store.commit('setRefreshDataSegmentList', true)
        }, // End of updateStatus() method

        // get records when pagination changed
        paginationChanged(type) {
            const perPage = type || 10
            this.query.perPage = perPage

            this.applySearch()
        }, // End of paginationChanged() method

        //apply filters and get matching records
        applySearch(type) {
            if (type && type == 'next') {
                this.query.startAt = this.pagination.next
            }

            if (type && type == 'previous') {
                this.query.startAt = this.pagination.current - 1
            }

            if (type && type == 'search') {
                this.query.startAt = 1
            }

            this.items = []
            this.showPageLoader = true
            if (type && type == 'search') {
                this.$store.commit('setLoading', true)
            }
            this.getRecords()
        }, // End of applySearch() method
    }, // End of Component > methods
} // End of export default
</script>
